export default {
  psw: "Κωδικός",
  topFive: "πέντε κορυφαία",
  confPsw: "Επιβεβαίωση Κωδικού",
  newPsw: "Νέος Κωδικός",
  email: "Email",
  emailId: "Αναγνωριστικό email",
  submit: "Υποβολή",
  cancel: "Ακύρωση",
  faqs: "Συχνά Ερωτήματα",
  users: "Χρήστες",
  appUser: "Χρήστες Εφαρμογής",
  app_users: "Χρήστες Εφαρμογής",
  dimitraAdmin: "Διαχειριστής Dimitra",
  admin_users: "Χρήστες Διαχείρισης",
  search: "αναζήτηση",
  searchBy: "αναζήτηση {type}",
  firstName: "Όνομα",
  lastName: "Επίθετο",
  mobile: "Κινητό Τηλέφωνο",
  mobileNumber: "Αριθμός Κινητού Τηλεφώνου",
  department: "Τμήμα",
  role: "Ρόλος Χρήστη",
  status: "Κατάσταση",
  permission: "Δικαιώματα",
  activity_log: "Αρχεία καταγραφής δραστηριοτήτων",
  profile_auth: "Ρυθμίσεις ελέγχου ταυτότητας προφίλ",
  countryCode: "Κωδικός χώρας",
  selectDept: "Επιλογή Τμήματος",
  selectRole: "Επιλογή Ρόλου",
  edit: "Επεξεργασία",
  update: "Ενημέρωση",
  delete: "Διαγραφή",
  view: "βλέπω",
  deactivate: "Απενεργοποίηση",
  activate: "Ενεργοποίηση",
  serverError: "Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε αργότερα..",
  minute: "Λεπτό",
  perHour: "Ανά ώρα",
  day: "Ημέρα",
  enterDescription: "Εισαγάγετε την περιγραφή σας εδώ",
  enterHere: "Είσοδος Εδώ",
  enterMobile: "Εισαγάγετε τον αριθμό κινητού τηλεφώνου",
  phoneRequired: "Ο αριθμός τηλεφώνου απαιτείται",
  phoneValid: "Ο αριθμός τηλεφώνου θα πρέπει να είναι έγκυρος",
  unableToUpdate: "Η ενημέρωση δεν ήταν δυνατή",
  membershipPlans: "Πλάνα Συνδρομής",
  byWeek: "Ανά Εβδομάδα",
  byMonth: "Ανά μήνα ",
  byYear: "Ανά Έτος",
  custom: "Προσαρμογή",
  name: "Όνομα",
  regionState: "Επαρχία/Νομός",
  provinceState: "Επαρχία/Πολιτεία",
  cityTown: "Πόλη/Κωμόπολη",
  membershipValidity: "Ισχύς Συνδρομής",
  exportAsCSV: "Εξαγωγή σε Μορφή CSV",
  filterBy: "Φιλτράρισμα κατά",
  comingSoon: "Προσεχώς",
  userRole: "Ρόλος Χρήστη",
  additionalInformationRequired: "Απαιτούνται πρόσθετες πληροφορίες",
  back: "Πίσω",
  browse: "Ξεφύλλισμα",
  approve: "Έγκριση ",
  reject: "Απόρριψη ",
  username: "Όνομα Χρήστη",
  phone: "Τηλέφωνο",
  roleAssigned: "Εκχώρηση Ρόλου",
  roleRequested: "Ζητούμενος Ρόλος",
  requestedDate: "Ζητούμενη Ημερομηνία",
  updateRoleRequest: "Αίτημα Ενημέρωσης Ρόλου",
  message: "μήνυμα",
  faqSection: {
    createFaq: "Δημιουργία Συχνών Ερωτημάτων",
    createTopic: "Δημιουργία Θέματος",
    selectTopic: "Επιλογή Θέματος ",
    faqQuestion: "FAQ Ερώτηση ",
    faqAnswer: "FAQ Απάντηση",
    uploadImgVid: "Μεταφόρτωση εικόνας/βίντεο",
    disInFaq: "Εμφάνιση στην ενότητα FAQ",
    editFaq: "Επεξεργασία FAQ",
    topicName: "Όνομα θέματος",
    parentTopic: "Όνομα Θέματος",
    editTopic: "Επεξεργασία Θέματος",
    createSection: "Please create section first",
    createTopicFirst: "Please create topic first",
    questionReq: "Η ερώτηση των συχνών ερωτήσεων είναι υποχρεωτική",
    answerReq: "Η απάντηση των συχνών ερωτήσεων είναι υποχρεωτική",
  },
  reports: {
    male: "Αρσενικό",
    female: "Γυναίκα",
    other: "Άλλα",
    farmerName: "Όνομα Αγρότη",
    farmerProdChart: "Διάγραμμα Αγροτικής Παραγωγής",
    production: "Παραγωγή",
    byProduction: "Ανά Παραγωγή",
    byName: "Ονομαστικά",
    descending: "Φθίνουσα",
    ascending: "Αύξουσα",
    buyingStationProdChart: "Διάγραμμα Παραγωγής Σταθμού Αγοράς",
    buyingStation: "Σταθμός Αγοράς",
    buyingStationName: "Όνομα Σταθμού Αγοράς",
    dryMilling: "Ξηρή Άλεση",
    dryMillingName: "Όνομα Ξηρής Άλεσης",
    dryMillingProdChart: "Διάγραμμα Παραγωγής Ξηρής Άλεσης",
    view: "Προβολή",
    date: "Ημερομηνία",
    reports: "Αναφορές",
  },
  traceability: {
    traceability: "ανιχνευσιμότητα",
    coffeeTraceabilityMngmnt: "Διαχείριση ανιχνευσιμότητας του καφέ",
    traceabilityPage: "Σελίδα ανιχνευσιμότητας",
    labelDesigner: "Σχεδιαστής ετικετών",
    additionalInformation: "Επιπλέον πληροφορίες",
    info1:
      "Παρέχετε πληροφορίες σχετικά με τα επιπρόσθετα λογότυπα του προϊόντος σας. Αυτές οι πληροφορίες θα είναι διαθέσιμες στο κοινό στη σελίδα ανιχνευσιμότητας του καφέ.",
    addSlogan: "Προσθήκη συνθήματος",
    sloganTooltip: "Προσθέστε ένα σύνθημα για το προϊόν σας",
    additionalLogos: "Επιπρόσθετα λογότυπα",
    title: "Τίτλος",
    description: "Περιγραφή",
    mapLink: "Σύνδεσμος χάρτη",
    websiteLink: "Σύνδεσμος ιστοσελίδας",
    addMedia: "Προσθήκη πολυμέσων",
    uploadImageVideo: "Ανέβασμα εικόνας/βίντεο",
    origin: "Προέλευση",
    info2:
      "Παρέχετε πληροφορίες σχετικά με τη χώρα προέλευσης του προϊόντος σας. Αυτές οι πληροφορίες θα είναι διαθέσιμες στο κοινό στη σελίδα ανιχνευσιμότητας του καφέ.",
    countryImage: "Εικόνα χώρας",
    institutionalInfo: "Θεσμικές πληροφορίες",
    info3:
      "Παρέχετε πληροφορίες σχετικά με την εταιρεία/συνεταιρισμό σας, ενημερώνοντας τους καταναλωτές για το σχετικό έργο που έχετε επιτελέσει. Αυτές οι πληροφορίες θα είναι διαθέσιμες στο κοινό στη σελίδα ανιχνευσιμότητας του καφέ.",
    cooperativeLogo: "Λογότυπο συνεταιρισμού",
    traceabilityIntro: "Εισαγωγή στην ανιχνευσιμότητα",
    info4:
      "Αυτή η ενότητα θα δώσει στον καταναλωτή πρόσβαση σε ολόκληρη την ιστορία παραγωγής και επεξεργασίας του καφέ. Περιγράψτε τη σημασία της ανιχνευσιμότητας για την εταιρεία/συνεταιρισμό και για τον κόσμο.",
    addLabel: "Προσθήκη ετικέτας",
    chooseTitle: "Επιλέξτε τίτλο",
    chooseLabelDesign: "Επιλέξτε πρότυπο σχεδιασμού ετικέτας",
    uploadYourLogo: "Ανεβάστε το λογότυπό σας",
    info5:
      "Οδηγίες: Το μέγεθος της εικόνας πρέπει να είναι τουλάχιστον 1000 x 1000 εικονοστοιχεία τετράγωνο. Μπορείτε να επιλέξετε ένα διαφανές PNG για να συγχρονιστεί με τα χρώματα του φόντου.",
    chooseTemplateColors: "Επιλογή χρωμάτων προτύπου",
    backgroundColor: "Χρώμα φόντου",
    foregroundColor: "Χρώμα εμπροσθοφόντου",
    labelStatus: "Κατάσταση ετικέτας",
    inactive: "Ανενεργό",
    download: "Λήψη",
    enterLabelTitle: "Εισαγωγή τίτλου ετικέτας",
  },
  cacaoTraceability: {
    traceability: "ανιχνευσιμότητα",
    cacaoTraceabilityMngmnt: "Διαχείριση ανιχνευσιμότητας του κακάο",
    traceabilityPage: "Σελίδα ανιχνευσιμότητας",
    labelDesigner: "Σχεδιαστής ετικετών",
    additionalInformation: "Επιπλέον πληροφορίες",
    info1:
      "Παρέχετε πληροφορίες σχετικά με τα επιπρόσθετα λογότυπα του προϊόντος σας. Αυτές οι πληροφορίες θα είναι διαθέσιμες στο κοινό στη σελίδα ανιχνευσιμότητας του κακάο.",
    addSlogan: "Προσθήκη συνθήματος",
    additionalLogos: "Επιπρόσθετα λογότυπα",
    title: "Τίτλος",
    description: "Περιγραφή",
    mapLink: "Σύνδεσμος χάρτη",
    websiteLink: "Σύνδεσμος ιστοσελίδας",
    addMedia: "Προσθήκη πολυμέσων",
    uploadImageVideo: "Ανέβασμα εικόνας/βίντεο",
    origin: "Προέλευση",
    info2:
      "Παρέχετε πληροφορίες σχετικά με τη χώρα προέλευσης του προϊόντος σας. Αυτές οι πληροφορίες θα είναι διαθέσιμες στο κοινό στη σελίδα ανιχνευσιμότητας του κακάο.",
    countryImage: "Εικόνα χώρας",
    institutionalInfo: "Θεσμικές πληροφορίες",
    info3:
      "Παρέχετε πληροφορίες σχετικά με την εταιρεία/συνεταιρισμό σας, ενημερώνοντας τους καταναλωτές για το σχετικό έργο που έχετε επιτελέσει. Αυτές οι πληροφορίες θα είναι διαθέσιμες στο κοινό στη σελίδα ανιχνευσιμότητας του κακάο.",
    cooperativeLogo: "Λογότυπο συνεταιρισμού",
    traceabilityIntro: "Εισαγωγή στην ανιχνευσιμότητα",
    info4:
      "Αυτή η ενότητα θα δώσει στον καταναλωτή πρόσβαση σε ολόκληρη την ιστορία παραγωγής και επεξεργασίας του κακάο. Περιγράψτε τη σημασία της ανιχνευσιμότητας για την εταιρεία/συνεταιρισμό και για τον κόσμο.",
    addLabel: "Προσθήκη ετικέτας",
    chooseTitle: "Επιλέξτε τίτλο",
    chooseLabelDesign: "Επιλέξτε πρότυπο σχεδιασμού ετικέτας",
    uploadYourLogo: "Ανεβάστε το λογότυπό σας",
    info5:
      "Οδηγίες: Το μέγεθος της εικόνας πρέπει να είναι τουλάχιστον 1000 x 1000 εικονοστοιχεία τετράγωνο. Μπορείτε να επιλέξετε ένα διαφανές PNG για να συγχρονιστεί με τα χρώματα του φόντου.",
    chooseTemplateColors: "Επιλογή χρωμάτων προτύπου",
    backgroundColor: "Χρώμα φόντου",
    foregroundColor: "Χρώμα εμπροσθοφόντου",
    labelStatus: "Κατάσταση ετικέτας",
    inactive: "Ανενεργό",
    download: "Λήψη",
    enterLabelTitle: "Εισαγωγή τίτλου ετικέτας",
  },
  setting: {
    profileAuthSetting: "Ρυθμίσεις ελέγχου ταυτότητας προφίλ",
    logInOutSetting: "Ρυθμίσεις Εισόδου/Εξόδου",
    autoLogout: "Αυτόματη Έξοδος",
    unsuccessfulLoginAttempt: "Αποτυχημένες Προσπάθειες Εισόδου",
    unsuccessfulLoginLockPeriod: "Ανεπιτυχής περίοδος Κλειδώματος σύνδεσης",
    passCriteriaSetup: "Ρύθμιση Κριτηρίων Κωδικού Πρόσβασης",
    passLength: "Μήκος Κωδικού Πρόσβασης",
    noUniquePassRequired: "Αριθμός μοναδικών κωδικών πρόσβασης που απαιτούνται",
    maxPassAge: "Μέγιστη περίοδος κωδικού πρόσβασης",
    acceptableRangeOfChars: "Αποδεκτή γκάμα χαρακτήρων ",
    upperCase: "Κεφαλαίο γράμμα",
    lowerCase: "Μικρό γράμμα",
    numbers: "αριθμοί",
    specialChars: "Ειδικοί χαρακτήρες",
    uniqueSymbols: "Μοναδικά σύμβολα",
    loadingData: "Φόρτωση Δεδομένων...",
    currency: "Νόμισμα",
    codeActivationTime: "Χρόνος Ενεργοποίησης Κώδικα",
    changeGlobalSetting: "Αλλαγή Παγκόσμιων Ρυθμίσεων",
    globalSetting: "Παγκόσμιες Ρυθμίσεις",
    generalSetting: "Γενικές Ρυθμίσεις",
    hour: "Ώρες",
    days: "Ημέρες",
    minutes: "Μήνες",
    perDay: "Ανά Ημέρα",
    perHour: "Ανά ώρα",
    customised: "Προσαρμοσμένο",
    smallFarm: "Μικρή φάρμα",
    inclusive: "Συμπεριληπτικός",
    from: "Από",
    to: "Έως",
    mediumFarm: "Μεσαία φάρμα",
    largeFarm: "Μεγάλη φάρμα",
    requiredMessage: "Αυτό το πεδίο είναι υποχρεωτικό",
    nonNegativeMessage: "Αυτό το πεδίο πρέπει να είναι μη αρνητικό",
    fieldToGreaterThanFrom: "Αυτό το πεδίο πρέπει να είναι μεγαλύτερο από το πεδίο 'Από'",
    fieldToGreaterThanFromMedium: "Αυτό το πεδίο πρέπει να είναι μεγαλύτερο από το πεδίο 'Έως' της μικρής φάρμας",
    fieldToGreaterThanMediumTo: "Αυτό το πεδίο πρέπει να είναι μεγαλύτερο από το πεδίο 'Έως' της μεσαίας φάρμας",
  },
  coffeeData: {
    windBreaker: "Δέντρο Προστασίας από τον Άνεμο",
    horticultureInfo: "Δενδροκηπευτικά",
    shadeTree: "Δέντρο σκιάς",
    coffeeVariety: "Ποικιλία καφέ",
    coffeeSpecies: "Είδη Καφέ",
    updateWindBreaker: "Ενημέρωση τύπου δέντρου που προστατεύει από τον άνεμο",
    addWindBreaker: "Προσθήκη Νέου Τύπου Δέντρου windBreaker",
    updateHorticultureInfo: "Ενημέρωση τύπου δέντρου δενδοκηπευτικού",
    addHorticultureInfo: "Προσθήκη νέου τύπου δέντρου κηπευτικών πληροφοριών",
    updateShadeTree: "Ενημέρωση Τύπου Δέντρου Σκιάς",
    addShadeTree: "Προσθήκη Νέου Τύπου Δέντρου Σκιάς ",
    updateCoffeeVariety: "Ενημέρωση Τύπου Δέντρου Ποικιλίας Καφέ",
    addCoffeeVariety: "Προσθήκη νέου τύπου δέντρου τύπου ποικιλίας καφέ",
    deleteVarietyTitle: "Διαγραφή ποικιλίας",
    deleteVarietyMessage:
      "Είστε βέβαιοι ότι θέλετε να διαγράψετε την Ποικιλία;",
    updateCoffeeSpecie: "Ενημέρωση του Είδους Καφέ",
    deleteSpecieTitle: "Διαγραφή είδους",
    deleteSpecieMessage: "Είστε βέβαιοι ότι θέλετε να διαγράψετε το Είδος;",
    addCoffeeSpecie: "Προσθήκη νέου είδους καφέ",
    variety: "Ποικιλία",
    selectVariety: "Επιλέξτε Ποικιλία",
    deleteCoffeeRecord: "Είστε βέβαιοι ότι θέλετε να διαγράψετε την καταγραφή;",
    deleteCoffeeData: "Διαγραφή Δεδομένων Καφέ",
    topicRequired: "Απαιτείται όνομα θέματος",
    coffeeAddSuccess: "Το είδος καφέ προστέθηκε με επιτυχία.",
    treeTypeSuccess: "Ο τύπος δέντρου προστέθηκε με επιτυχία.",
    treeTypeUpdateSuccess: "Ο τύπος δέντρου ενημερώθηκε με επιτυχία.",
    coffeeVarietySuccess: "Η ποικιλία καφέ προστέθηκε με επιτυχία.",
    coffeeSpecieSuccess: "Το είδος του καφέ ενημερώθηκε με επιτυχία.",
    nameRequired: "Το όνομα απαιτείται",
    notFound: "Δεν βρέθηκαν δεδομένα Διαχείρισης Καφέ",
  },
  plantation: {
    farmerName: "Όνομα Αγρότη",
    phoneNumber: "Αριθμός Τηλεφώνου",
    plantationName: "Όνομα φυτείας",
    farm: "Φάρμα",
    location: "Τοποθεσία",
    updatePlantationStatus: "Ενημέρωση Κατάστασης Φυτείας",
    update: "Ενημέρωση",
  },
  activationKey: {
    enterActivationKey: "Εισαγάγετε το κλειδί ενεργοποίησης για να εγγράψετε νέο χρήστη",
    activationKeyLimit: "Το κλειδί ενεργοποίησης είναι πολύ σύντομο",
    countryRequired: "Η χώρα είναι υποχρεωτική",
    activationKey: "Κλειδια Ενεργοποίησης",
    appointSalesManager: "Ορίστε Διευθυντή Πωλήσεων",
    appointManager: "ΔΙΟΡΙΣΤΕ ΔΙΕΥΘΥΝΤΗ",
    salesManAppSuccess: "Ο ΔΙΕΥΘΥΝΤΗΣ ΠΩΛΗΣΕΩΝ ΟΡΙΣΘΗΚΕ ΜΕ ΕΠΙΤΥΧΙΑ",
    uploadData: "ΜΕΤΑΦΟΡΤΩΣΗ ΕΚΧΩΡΗΜΕΝΩΝ ΔΕΔΟΜΕΝΩΝ CSV",
    uploadUserData: "Παρακαλώ ανβάστε το αρχείο δεδομένων χρήστη.",
    downloadCsv:
      "(Κατεβάστε το δείγμα αρχείου .csv για να ακολουθήσετε τη δομή)",
    downloadSample: "Λήψη δείγματος αρχείου",
    dragDrop: "Σύρετε και αποθέστε ή περιηγηθείτε στο αρχείο σας.",
    browse: "φυλλομετρώ",
    yourFile: "το αρχείο σας",
    incorectFileType: "Λανθασμένος τύπος αρχείου",
    somethingWentWrong: "Κάτι πήγε λάθος ",
    fileUploadedSuccess: "Το αρχείο ανέβηκε επιτυχώς",
    countRecords: "Καταμέτρηση Εγγραφών",
    sendNow: "ΑΠΟΣΤΟΛΗ ΤΩΡΑ",
    fileName: "όνομα αρχείου",
    assignActKey: "Εκχώρηση κλειδιών ενεργοποίησης",
    actKeyAssSucc: "Τα κλειδιά ενεργοποίησης εκχωρήθηκαν με επιτυχία",
    viewActKey: "ΠΡΟΒΟΛΗ ΚΛΕΙΔΙΩΝ ΕΝΕΡΓΟΠΟΙΗΣΗΣ",
    actKeyQuota: "Ποσοστό Κλειδιών Ενεργοποίησης",
    genActKey: "Κλειδιά Ενεργοποίησης που Δημιουργήθηκαν",
    remActKey: "Εναπομείναντα Κλειδιά Ενεργοποίησης",
    penUsed: "Κλειδιά σε Εκκρεμότητα και Χρησιμοποιημένα Κλειδιά",
    activationKeyAss: "Εκχωρημένα Κλειδιά Ενεργοποίησης",
    activationKeyUnass: "Μη Εκχωρημένα Κλειδιά Ενεργοποίησης",
    keysAct: "Κλειδιά που Ενεργοποιήθηκαν",
    uploadedFiles: "Ανεβασμένα Αρχεία",
    generateActKey: "ΔΗΜΙΟΥΡΓΙΑ ΚΛΕΙΔΙΩΝ ΕΝΕΡΓΟΠΟΙΗΣΗΣ",
    showData: "Εμφάνιση δεδομένων",
    noDataFound: "Δεν βρέθηκε ημερομηνία",
    pleaseGenKey:
      'Δημιουργήστε τα κλειδιά ενεργοποίησης χρησιμοποιώντας το "Δημιουργία κλειδιών ενεργοποίησης"',
    noActKey: "Δεν έχουν δημιουργηθεί ακόμη κλειδιά ενεργοποίησης",
    buttonAbv: "κουμπί πάνω",
    numberOfActKey: "Αριθμός Κλειδιών Ενεργοποίησης",
    membershipRole: "Ρόλος Μέλους",
    membershipPlan: "Προσθήκη προγράμματος μέλους",
    comments: "Σχόλια",
    genKeys: "ΔΗΜΙΟΥΡΓΙΑ ΚΛΕΙΔΙΩΝ",
    keysNum: "Αριθμός Κλειδιών",
    phoneNumber: "Αριθμός Τηλεφώνου",
    keysStatus: "Κατάσταση Κλειδιών",
    ActivationKeysList: "Λίστα Κλειδιών Ενεργοποίησης",
    back: "ΠΙΣΩ",
    usingActKeys: 'χρησιμοποιώντας το "Δημιουργία κλειδιών ενεργοποίησης"',
    pleaseGenActKeyss: "Δημιουργήστε τα κλειδιά ενεργοποίησης",
    clearAllFilters: "ΔΙΑΓΡΑΦΗ ΟΛΩΝ ΤΩΝ ΦΙΛΤΡΩΝ",
    salesManager: "Υπεύθυνος Πωλήσεων",
    clearAll: "ΕΚΚΑΘΑΡΙΣΗ ΟΛΩΝ",
    generatedBy: "Δημιουργήθηκε από",
    numberOfKeys: "Αριθμός Κλειδιών",
    action: "Ενέργεια",
    viewAllUplFiles: "Προβολή όλων των ανεβασμένων αρχείων",
    bulkUploadUsers: "ΜΑΖΙΚΗ ΜΕΤΑΦΟΡΤΩΣΗ ΧΡΗΣΤΩΝ",
    noActivationKeyFound: "Δεν βρέθηκαν κλειδιά ενεργοποίησης",
    pleaseCreateAdminRole: "Δημιουργήστε ρόλο διαχειριστή χρησιμοποιώντας το",
    btnCreateAdmin: 'κουμπί "Δημιουργία ρόλου διαχειριστή" παραπάνω',
    donwloadAsCsv: "Λήψη ως CSV",
    donwloadAsPdf: "Λήψη ως PDF",
    assignSalesManager: "Αναθέστε Υπεύθυνο Πωλήσεων",
    shareViaEmail: "Κοινή χρήση μέσω email",
    sendEmail: "ΝΑ ΣΤΕΙΛΕΤΕ E-MAIL",
    emailSend: "Το email εστάλη με επιτυχία",
    donwload: "Κατέβασμα",
    deleteFile: "Διαγραφή φακέλου",
    invalidFileData:
      "Τα δεδομένα του κλειδιού ενεργοποίησης στο αρχείο δεν είναι έγκυρα",
    continue: "Συνέχεια",
    description: "Περιγραφή",
    selectWeek: "Επιλογή εβδομάδας",
    confirm: "ΕΠΙΒΕΒΑΙΩΝΩ",
    selectMonth: "Επιλέξτε μήνα",
    selectDateRange: "Επιλέξτε Εύρος ημερομηνιών",
    regionDistrict: "Περιφέρεια/Επαρχία",
    address: "Διεύθυνση",
    familyTribe: "Οικογενειακή Φυλή",
    website: "Ιστότοπος",
    deactivated: "Μη ενεργός",
    active: "Ενεργός",
    country: "Χώρα",
    farmer: "Αγρότης",
    commodity: "Εμπόρευμα",
    quantity: "Ποσότητα",
    unit: "Μονάδα",
    price: "Τιμή",
    save: "ΑΠΟΘΗΚΕΥΣΕΤΕ",
    stateIsReq: "απαιτείται κράτος",
    cityIsReq: "Η πόλη είναι απαραίτητη",
    addressIsReq: "Address is required",
    membershipTypeReq: "Membership type is required",
    extendedReasonReq: "Extend reason is required",
    numberOfDaysReq: "Number of days is required",
    extendedMembershipValidity: "Επέκτεινόμενη Διάρκεια Ισχύος Μέλους",
    set: "SET",
    adminRole: "Yönetici Rolleri",
    typeMsg: "Type your message here",
    errors: {
      cannotBeBlank: "Αυτό το πεδίο δεν μπορεί να είναι κενό",
      required: "Αυτό το πεδίο είναι υποχρεωτικό",
      somethingWentWrong: "Κάτι πήγε λάθος !!!",
    },
    loadingData: "Φόρτωση Δεδομένων...",
    markAsRead: "Επισήμανση ως Αναγνωσμένο",
    membership: {
      remainingDays: "Αριθμός ημερών που απομένουν",
      type: "Τύπος Συνδρομής",
      validity: "Εγκυρότητα Συνδρομής",
      validityLength: {
        custom: "Προσαρμογή",
        expired: "Έχει λήξει",
        oneTo8Months: "1-8 μηνών",
        lessThan1Month: "Λιγότερο από 1 Μήνας",
        moreThan1Month: "Περισσότερο από 1 χρόνος",
        sixTo12Months: "6-12 Μήνες",
      },
    },
    of: "του",
    ok: "ΟΚ",
    statusItems: {
      closed: "Κλειστό",
      open: "Ανοιχτό",
    },
    orderByItems: {
      all: "Όλα",
      dateAscending: "Ημερομηνία Αύξουσα",
      dateDescending: "Ημερομηνία Φθίνουσα",
      dueDate: "Ημερομηνία Λήξης",
      high: "Υψηλότερα",
      low: "Χαμηλότερα",
      medium: "Μεσαία",
    },
    orderBy: "Ταξινόμηση κατά",
    select: "Επιλογή",
    type: "Τύπος",
    uploadImageVideo: "Ανέβασμα Εικόνων/Βίντεο",
    user: "Χρήστες",
    userName: "Όνομα Χρήστη",
    usersSelected: "Χρήστες που Επιλέχθηκαν",
    topics: "Θέματα",
    date: "Ημερομηνία",
    addNew: "ΠΡΟΣΘΕΣΕ ΝΕΟ",
    exportAsCsv: "Εξαγωγή σε Μορφή CSV",
    noData: "Δε βρέθηκαν δεδομένα",
    login: {
      welcomeMsg: "Καλωσήρθατε! Σύνδεση",
      info: "Εισαγάγετε τα στοιχεία σας.",
      forgot: "Ξεχάσατε τον κωδικό σας;",
      btn: "Είσοδος",
      unableToLogin: "Αδυναμία Εισόδου",
    },
    forgot: {
      info_l1:
        "Παρακαλώ, εισάγετε τη διεύθυνση ηλεκτρονικού ταχυδρομείου που σχετίζεται με το λογαριασμό σας. Τα στοιχεία του κωδικού πρόσβασης θα σταλούν στη διεύθυνση email/κινητό σας.",
      info_l2:
        "Παρακαλώ εισαγάγετε τον αριθμό του κινητού σας που σχετίζεται με τον λογαριασμό σας. Τα στοιχεία του κωδικού πρόσβασης θα σταλούν στον αριθμό τηλεφώνου.",
      info_l3:
        "Παρακαλώ επιλέξτε μία από τις παρακάτω επιλογές για να λάβετε οδηγίες σχετικά με τον τρόπο επαναφοράς του κωδικού πρόσβασής σας",
      forgotQ: "Ξεχάσατε τον κωδικό σας;",
      loginNow: "Είσοδος Τώρα",
      resetSucc: "Ο κωδικός πρόσβασής σας έχει αλλάξει με επιτυχία",
      resetSucc_l2:
        "Τώρα μπορείτε να χρησιμοποιήσετε τον νέο σας κωδικό πρόσβασης για να συνδεθείτε στον λογαριασμό σας.",
      entPsw: "Εισαγάγετε τον νέο σας κωδικό πρόσβασης.",
      resetPsw: "Επαναφορά του κωδικού πρόσβασής σας",
      resendOTP: "Επανάληψη αποστολής OTP",
      enterCorrectOTP: "Εισαγάγετε το σωστό OTP.",
      enterOTP: "Εισαγάγετε το OTP που λάβατε στο email/κινητό",
      backToLoginPage: "Επιστροφή στη σελίδα εισόδου",
      recieveCodeFalse: " Δεν έλαβα τον κωδικό",
    },
    dashboard: "Πίνακας Ελέγχου",
    userslist: {
      createNewUser: "Create a New User",
      chooseCreateType: "Please choose one of the following options:",
      addNewUser: "Προσθήκη Νέου Χρήστη",
      editUser: "Επεξεργασία Χρήστη",
      addNewAdmin: "Προσθήκη Χρήστη Διαχείρισης",
      userLoading: "Φόρτωση χρηστών... Παρακαλώ περιμένετε",
      noUser: "ΔΕΝ ΥΠΑΡΧΕΙ ΔΙΑΘΕΣΙΜΟΣ ΧΡΗΣΤΗΣ",
      extendVal: "ΕΠΕΚΤΑΣΗ ΙΣΧΥΟΣ",
      extendReason: "Λόγος Παράτασης",
      extendReasonMsg: "Προσδιορίστε τον λόγο για την επέκταση της συνδρομής",
      exportAsCSV: "Εξαγωγή σε Μορφή CSV",
      membershipType: "Τύπος Συνδρομής",
      membershipValidity: "Εγκυρότητα Συνδρομής",
      regionState: "Επαρχία/Νομός",
      cityTown: "Πόλη/Κωμόπολη",
      clearAll: "ΕΚΚΑΘΑΡΙΣΗ ΟΛΩΝ",
      search: "ΑΝΑΖΗΤΗΣΗ",
    },
    addEdituser: {
      firstNameRequired: "First Name is required",
      firstNameOllyAlpha: "First Name can contain only alphabets",
      firstNameLimit: "First Name must be less than 15 characters",
      lastNameRequired: "Το Επώνυμο είναι υποχρεωτικό",
      lastNameOllyAlpha: "Last Name can contain only alphabets",
      lastNameLimit: "Το επώνυμο πρέπει να είναι λιγότερο από 15 χαρακτήρες",
      emailReuired: "Το email είναι υποχρεωτικό",
      emailInvalid: "Μη έγκυρη μορφή email.",
      mobileRequired: "Ο αριθμός κινητού τηλεφώνου είναι υποχρεωτικός",
      invalidMobile: "Μη έγκυρη μορφή αριθμού κινητού τηλεφώνου.",
      pswRequired: "Ο κωδικός πρόσβασης είναι υποχρεωτικός",
      deptRequired: "Το τμήμα είναι υποχρεωτικό",
      roleRequired: "Ο ρόλος είναι υποχρεωτικός",
      countryRequired: "Ο Κωδικός Χώρος είναι υποχρεωτικός",
      userUpdated: "Ο Χρήστης Ενημερώθηκε",
      userNotUpdated: "Ο Χρήστης Δεν Ενημερώθηκε",
      activateAct: "Ενεργοποίηση Λογαριασμού",
      deactivateAct: "Απενεργοποίηση Λογαριασμού",
      userActivated: "Ενεργοποιημένος Χρήστης",
      userDeactivated: "Απενεργοποιημένος Χρήστης",
      deactivateUser: "Απενεργοποίηση Χρήστη",
      deactivateMsg:
        "Είστε βέβαιοι ότι θέλετε να αλλάξετε την κατάσταση χρήστη.",
      userAdded: "Προστέθηκε Χρήστης",
      userNotAdded: "Ο Χρήστης Δεν Προστέθηκε",
      validityUpTo: "Validity Up To",
      facilityPicture: "Facility Picture",
      editAppUser: "Επεξεργασία χρήστη εφαρμογής",
    },
    permissions: {
      savePermissions: "ΑΠΟΘΗΚΕΥΣΗ ΔΙΚΑΙΩΜΑΤΩΝ",
      moduleName: "Όνομα ενότητας",
      view: "Προβολή",
      create: "Δημιουργία",
      update: "Ενημέρωση",
      delete: "Διαγραφή",
      permissionsUpdated: "Ενημέρωση Δικαιωμάτων",
      permissionsNotUpdated: "Τα Δικαιώματα δεν Ενημερώθηκαν",
      selectMembership: "Επιλογή Συνδρομής",
      noPermMsg:
        'Επιλέξτε τον τύπο συνδρομής χρησιμοποιώντας το αναπτυσσόμενο μενού "Τύπος μέλους" παραπάνω για να δείτε τα δικαιώματά σας',
      selectRoleMsg:
        "Επιλέξτε τον παραπάνω ρόλο για να εμφανιστούν τα δικαιώματα",
    },
    logs: {
      time: "Ώρα",
      username: "Όνομα Χρήστη",
      role: "Ρόλος Χρήστη",
      terminalID: "ID Τερματικού",
      moduleAccessed: "Η Ενότητα Έχει Γίνει Προσβάσιμη",
      typeOfAccess: "Τύπος Πρόσβασης",
      activityLogDetails: "Λεπτομέρειες αρχείου καταγραφής δραστηριοτήτων",
      userId: "Αναγνωριστικό Χρήστη",
      lastLogin: "Τελευταία Είσοδος",
      geoAccPoint: "Γεωγραφικό σημείο πρόσβασης",
      ipAdd: "Διεύθυνση IP",
      filesAccessed: "Τα Αρχεία Έγιναν Προσβάσιμα",
      funAccessed: "Η Λειτουργία Έγινε Προσβάσιμη",
      webUrl: "URL Ιστοσελίδας",
      unsuccAtmp: "Ανεπιτυχής προσπάθεια Εισόδου",
      view: "Προβολή",
      membershipType: "Τύπος Συνδρομής",
    },
    profileSetting: {
      profileAuthSettings: "Ρυθμίσεις ελέγχου ταυτότητας προφίλ",
      changeSettings: "Αλλαγή Ρυθμίσεων",
      loginLogoutSettings: "Login/Logoff Settings",
      autoLogout: "Auto-log off",
      unsuccAtmp: "Αποτυχημένες Προσπάθειες Σύνδεσης",
      unsuccLoginLock: "Ανεπιτυχής περίοδος Κλειδώματος σύνδεσης",
      pswCrisetup: "Ρύθμιση Κριτηρίων Κωδικού Πρόσβασης",
      pswLength: "Μήκος Κωδικού Πρόσβασης",
      noOfUniquePsw: "Αριθμός μοναδικών κωδικών πρόσβασης που απαιτούνται ",
      maxPswAge: "Μέγιστη περίοδος κωδικού πρόσβασης",
      AccRangeOfchars: "Αποδεκτή γκάμα χαρακτήρων",
      upperCase: "Κεφαλαίο γράμμα",
      lowerCase: "Μικρό γράμμα",
      numbers: "αριθμοί",
      specialChars: "Ειδικοί χαρακτήρες",
      settingsUpdated: "Οι Ρυθμίσεις Ενημερώθηκαν",
      settingsNotUpdated: "Οι Ρυθμίσεις Δεν Ενημερώθηκαν",
    },
    dashboardSection: {
      modules: "Ενότητες",
      allowances: "Όρια",
      maxUserAllowed: "Ανώτατο Όριο Επιτρεπόμενων Χρηστών ",
      satelliteReportsAllowed: "Επιτρεπόμενες Δορυφορικές Αναφορές ",
      advanceReport: "Επιτρεπόμενες Προχωρημένες Αναφορές ",
      subscriptionUpTo: "Συνδρομή Έως",
      roleAllowed: "Επιτρεπόμενοι Ρόλοι ",
      moduleAllowed: "Επιτρεπόμενες Ενότητες ",
      registeredUsers: "Εγεγγραμένοι Χρήστες",
      validMemberships: "Έγκυρες Συνδρομές",
      activeUsers: "Ενεργοί Χρήστες",
      deactivatedUsers: "Απενεργοποιημένοι Χρήστες",
      membershipValidity: "Ισχύς Συνδρομής",
      lessThan1Month: "Λιγότερο από 1 Μήνας",
      months1to6: "1-6 Μήνες",
      months6to12: "6-12 Μήνες",
      moreThan1Year: "Περισσότερο από 1 χρόνος ",
      cropOverview: "Επισκόπηση Περικοπής",
      plantations: "Φυτείες ",
      coffeeData: "Δεδομένα Καφέ",
      availableModules: "Διαθέσιμες Ενότητες",
      roleList: "Αγρότης, Σταθμός Αγοράς, Αποθήκη",
      memberData: "Δεδομένα Μέλους",
      userType: "Τύπος Χρήστη",
      registered: "Εγγεγραμμένο",
      offlineUsers: "Χρήστες εκτός σύνδεσης",
      lessThanOneMonth: "< 1 Μήνας",
      cacaoData: "Δεδομένα Κακάο",
      dryCacao: "Ξηρό Κακάο",
      traceability: "Εντοπισιμότητα",
    },
    adminRoles: {
      adminRoles: "Ρόλοι Διαχειριστών",
      roleName: "Όνομα Ρόλου",
      description: "Περιγραφή",
      viewPermissions: "Προβολή Δικαιωμάτων",
      createAdminRole: "ΔΗΜΙΟΥΡΓΙΑ ΡΟΛΟΥ ΔΙΑΧΕΙΡΙΣΤΗ",
      enterDesHere: "Εισαγάγετε την περιγραφή σας εδώ",
      deleteRole: "Διαγραφή Ρόλου",
      deleteMsg: "Είστε βέβαιοι ότι θέλετε να διαγράψετε έναν ρόλο;",
      roleReq: "Απαιτείται όνομα ρόλου",
      roleLimit:
        "Το όνομα του ρόλου πρέπει να είναι λιγότερο από 15 χαρακτήρες",
      desReq: "Απαιτείται περιγραφή",
      desLimit:
        "Η περιγραφή πρέπει να αποτελείται από 40 χαρακτήρες ή λιγότερους",
      roleSuccess: "Ο ρόλος δημιουργήθηκε με επιτυχία",
      editAdminRole: "Επεξεργασία Ρόλου Διαχειριστή",
      roleUpdated: "Ο ρόλος ενημερώθηκε ",
      noRole: "Δεν βρέθηκαν ρόλοι διαχειριστή",
      noRoleMsg:
        'Δημιουργήστε ρόλο διαχειριστή χρησιμοποιώντας το κουμπί "Δημιουργία ρόλου διαχειριστή" παραπάνω',
    },
    membershipplanSection: {
      defaultPlan: " Αλλαγή προεπιλεγμένου σχεδίου",
      planType: "ΤΥΠΟΣ ΣΧΕΔΙΟΥ",
      planDuration: "Διάρκεια Πλάνου",
      planFee: "Αντίτιμο Πλάνου",
      satelliteReport: "Δορυφορικές αναφορές",
      advanceReport: "ΠΡΟΧΩΡΗΜΕΝΗ ΑΝΑΦΟΡΑ",
      addMembership: "Προσθήκη Συνδρομής",
      addMembershipPlan: "Προσθήκη Πλάνου Συνδρομής",
      editMembershipPlan: "Επεξεργασία Πλάνου Συνδρομής",
      accessSetelite: "Πρόσβαση σε Δορυφορικές Αναφορές (Σετ 5 αναφορών)",
      accessAdvanceReport: "Πρόσβαση σε Προχωρημένες Αναφορές",
      memPlanReq: "Απαιτείται σχέδιο μέλους",
      memPlanReqLimit:
        "Το σχέδιο συνδρομής πρέπει να είναι λιγότερο από 20 χαρακτήρες",
      SatelliteReq: "Απαιτείται δορυφορική αναφορά",
      advancedReportReq: "Απαιτείται προηγμένη αναφορά",
      durationReq: "Απαιτείται διάρκεια συνδρομής",
      feeReq: "Απαιτείται συνδρομή μέλους",
      cantLesThenZero: "Δεν μπορεί να είναι μικρότερο από 0",
      roleReq: "Απαιτείται ο ρόλος χρήστη",
    },
    tickets: {
      actions: {
        create: "Δημιουργία Αιτήματος",
        delete: "διαγραφή αιτήματος",
        edit: "επεξεργασία αιτήματος",
      },
      areaOfRequest: "Ενότητα Αιτήματος",
      assignee: "Εκχωρημένο",
      deleteTicket: {
        confirmation: "Είστε σίγουροι ότι θέλετε να διαγράψετε {0} αιτήματα;",
      },
      dueDate: "Ημερομηνία Λήξης",
      filters: {
        ticketFor: "Αίτημα για",
      },
      form: {
        ticketType: {
          admin: "Δημιουργία Αιτήματος για τον Διαχειριστή Dimitra",
          user: "Δημιουργία Αιτήματος για το Χρήστη Εφαρμογής",
        },
      },
      markAsRead: "Επισήμανση ως Αναγνωσμένο",
      messages: {
        created: {
          success: "Το αίτημα δημιουργήθηλε επιτυχώς",
        },
        deleted: {
          success: "Το αίτημα διαγράφηκε επιτυχώς",
        },
      },
      noData: "Δεν Βρέθηκαν Αιτήματα",
      noDataHelpText: `Δεν σας έχουν εκχωρηθεί ακόμη αιτήματα{0}. Κάντε κλικ στο κουμπί "Δημιουργία αιτήματος"{1}στο επάνω μέρος αυτής της οθόνης για να ξεκινήσετε.`,
      pickerInMenu: "Επιλογή στο μενού",
      priority: {
        high: "Υψηλότερα",
        label: "Προτεραιότητα",
      },
      reply: "Απάντηση",
      requestedDateTime: "Ζητήθηκε ημερομηνία και ώρα",
      requestorDetails: "Στοιχεία αιτούντος",
      requestorEmail: "Email αιτούντα",
      subject: "θέμα",
      ticketsForItems: {
        all: "Όλα",
        dimitraAdmin: "Διαχειριστής Dimitra",
        multipleUsers: "Πολλαπλοί Χρήστες",
        singleUser: "Ένας Χρήστης",
      },
      title: "Αιτήματα",
    },
    roleRequest: {
      roleRequest: "Αίτημα Ρόλου",
      userRole: "Ρόλος Χρήστη",
      approve: "Έγκριση ",
      reject: "Απόρριψη ",
      username: "Όνομα Χρήστη",
      email: "Email",
      phone: "Τηλέφωνο",
      roleAssigned: "Εκχώρηση Ρόλου",
      roleRequested: "Ζητούμενος Ρόλος",
      requestedDate: "Ζητούμενη Ημερομηνία",
      updateRoleRequest: "Update Role RequestΑίτημα Ενημέρωσης Ρόλου ",
      message: "μήνυμα",
      update: "Ενημέρωση",
    },
    faqSection: {
      createFaq: "Δημιουργία Συχνών Ερωτημάτων",
      createTopic: "Δημιουργία Θέματος",
      selectTopic: "Επιλογή Θέματος ",
      faqQuestion: "FAQ Ερώτηση ",
      faqAnswer: "FAQ Απάντηση",
      uploadImgVid: "Μεταφόρτωση εικόνας/βίντεο",
      disInFaq: "Εμφάνιση στην ενότητα FAQ",
      editFaq: "Επεξεργασία FAQ",
      topicName: "Όνομα θέματος",
      parentTopic: "Όνομα Θέματος",
      editTopic: "Επεξεργασία Θέματος",
      createSection: "Please create section first",
      createTopicFirst: "Please create topic first",
      questionReq: "FAQ Question is required",
      answerReq: "FAQ Answer is required",
    },
    reports: {
      farmerName: "Όνομα Αγρότη",
      farmerProdChart: "Διάγραμμα Αγροτικής Παραγωγής",
      production: "Παραγωγή",
      byProduction: "Ανά Παραγωγή",
      byName: "Ονομαστικά",
      descending: "Φθίνουσα",
      ascending: "Αύξουσα",
      buyingStationProdChart: "Διάγραμμα Παραγωγής Σταθμού Αγοράς",
      buyingStation: "Σταθμός Αγοράς",
      buyingStationName: "Όνομα Σταθμού Αγοράς",
      dryMilling: "Ξηρή Άλεση",
      dryMillingName: "Όνομα Ξηρής Άλεσης",
      dryMillingProdChart: "Διάγραμμα Παραγωγής Ξηρής Άλεσης",
      view: "Προβολή",
      date: "Ημερομηνία",
      reports: "Αναφορές",
    },
    traceability: {
      traceability: "ανιχνευσιμότητα",
      coffeeTraceabilityMngmnt: "Διαχείριση ανιχνευσιμότητας του καφέ",
      traceabilityPage: "Σελίδα ανιχνευσιμότητας",
      labelDesigner: "Σχεδιαστής ετικετών",
      additionalInformation: "Επιπλέον πληροφορίες",
      info1:
        "Παρέχετε πληροφορίες σχετικά με τα επιπρόσθετα λογότυπα του προϊόντος σας. Αυτές οι πληροφορίες θα είναι διαθέσιμες στο κοινό στη σελίδα ανιχνευσιμότητας του καφέ.",
      addSlogan: "Προσθήκη συνθήματος",
      additionalLogos: "Επιπρόσθετα λογότυπα",
      title: "Τίτλος",
      description: "Περιγραφή",
      mapLink: "Σύνδεσμος χάρτη",
      websiteLink: "Σύνδεσμος ιστοσελίδας",
      addMedia: "Προσθήκη πολυμέσων",
      uploadImageVideo: "Ανέβασμα εικόνας/βίντεο",
      origin: "Προέλευση",
      info2:
        "Παρέχετε πληροφορίες σχετικά με τη χώρα προέλευσης του προϊόντος σας. Αυτές οι πληροφορίες θα είναι διαθέσιμες στο κοινό στη σελίδα ανιχνευσιμότητας του καφέ.",
      countryImage: "Εικόνα χώρας",
      institutionalInfo: "Θεσμικές πληροφορίες",
      info3:
        "Παρέχετε πληροφορίες σχετικά με την εταιρεία/συνεταιρισμό σας, ενημερώνοντας τους καταναλωτές για το σχετικό έργο που έχετε επιτελέσει. Αυτές οι πληροφορίες θα είναι διαθέσιμες στο κοινό στη σελίδα ανιχνευσιμότητας του καφέ.",
      cooperativeLogo: "Λογότυπο συνεταιρισμού",
      traceabilityIntro: "Εισαγωγή στην ανιχνευσιμότητα",
      info4:
        "Αυτή η ενότητα θα δώσει στον καταναλωτή πρόσβαση σε ολόκληρη την ιστορία παραγωγής και επεξεργασίας του καφέ. Περιγράψτε τη σημασία της ανιχνευσιμότητας για την εταιρεία/συνεταιρισμό και για τον κόσμο.",
      addLabel: "Προσθήκη ετικέτας",
      chooseTitle: "Επιλέξτε τίτλο",
      chooseLabelDesign: "Επιλέξτε πρότυπο σχεδιασμού ετικέτας",
      uploadYourLogo: "Ανεβάστε το λογότυπό σας",
      info5:
        "Οδηγίες: Το μέγεθος της εικόνας πρέπει να είναι τουλάχιστον 1000 x 1000 εικονοστοιχεία τετράγωνο. Μπορείτε να επιλέξετε ένα διαφανές PNG για να συγχρονιστεί με τα χρώματα του φόντου.",
      chooseTemplateColors: "Επιλογή χρωμάτων προτύπου",
      backgroundColor: "Χρώμα φόντου",
      foregroundColor: "Χρώμα εμπροσθοφόντου",
      labelStatus: "Κατάσταση ετικέτας",
      inactive: "Ανενεργό",
      download: "Λήψη",
      enterLabelTitle: "Εισαγωγή τίτλου ετικέτας",
    },
    cacaoTraceability: {
      traceability: "ανιχνευσιμότητα",
      cacaoTraceabilityMngmnt: "Διαχείριση ανιχνευσιμότητας του κακάο",
      traceabilityPage: "Σελίδα ανιχνευσιμότητας",
      labelDesigner: "Σχεδιαστής ετικετών",
      additionalInformation: "Επιπλέον πληροφορίες",
      info1:
        "Παρέχετε πληροφορίες σχετικά με τα επιπρόσθετα λογότυπα του προϊόντος σας. Αυτές οι πληροφορίες θα είναι διαθέσιμες στο κοινό στη σελίδα ανιχνευσιμότητας του κακάο.",
      addSlogan: "Προσθήκη συνθήματος",
      additionalLogos: "Επιπρόσθετα λογότυπα",
      title: "Τίτλος",
      description: "Περιγραφή",
      mapLink: "Σύνδεσμος χάρτη",
      websiteLink: "Σύνδεσμος ιστοσελίδας",
      addMedia: "Προσθήκη πολυμέσων",
      uploadImageVideo: "Ανέβασμα εικόνας/βίντεο",
      origin: "Προέλευση",
      info2:
        "Παρέχετε πληροφορίες σχετικά με τη χώρα προέλευσης του προϊόντος σας. Αυτές οι πληροφορίες θα είναι διαθέσιμες στο κοινό στη σελίδα ανιχνευσιμότητας του κακάο.",
      countryImage: "Εικόνα χώρας",
      institutionalInfo: "Θεσμικές πληροφορίες",
      info3:
        "Παρέχετε πληροφορίες σχετικά με την εταιρεία/συνεταιρισμό σας, ενημερώνοντας τους καταναλωτές για το σχετικό έργο που έχετε επιτελέσει. Αυτές οι πληροφορίες θα είναι διαθέσιμες στο κοινό στη σελίδα ανιχνευσιμότητας του κακάο.",
      cooperativeLogo: "Λογότυπο συνεταιρισμού",
      traceabilityIntro: "Εισαγωγή στην ανιχνευσιμότητα",
      info4:
        "Αυτή η ενότητα θα δώσει στον καταναλωτή πρόσβαση σε ολόκληρη την ιστορία παραγωγής και επεξεργασίας του κακάο. Περιγράψτε τη σημασία της ανιχνευσιμότητας για την εταιρεία/συνεταιρισμό και για τον κόσμο.",
      addLabel: "Προσθήκη ετικέτας",
      chooseTitle: "Επιλέξτε τίτλο",
      chooseLabelDesign: "Επιλέξτε πρότυπο σχεδιασμού ετικέτας",
      uploadYourLogo: "Ανεβάστε το λογότυπό σας",
      info5:
        "Οδηγίες: Το μέγεθος της εικόνας πρέπει να είναι τουλάχιστον 1000 x 1000 εικονοστοιχεία τετράγωνο. Μπορείτε να επιλέξετε ένα διαφανές PNG για να συγχρονιστεί με τα χρώματα του φόντου.",
      chooseTemplateColors: "Επιλογή χρωμάτων προτύπου",
      backgroundColor: "Χρώμα φόντου",
      foregroundColor: "Χρώμα εμπροσθοφόντου",
      labelStatus: "Κατάσταση ετικέτας",
      inactive: "Ανενεργό",
      download: "Λήψη",
      enterLabelTitle: "Εισαγωγή τίτλου ετικέτας",
    },
    setting: {
      profileAuthSetting: "Ρυθμίσεις ελέγχου ταυτότητας προφίλ",
      logInOutSetting: "Ρυθμίσεις Εισόδου/Εξόδου",
      autoLogout: "Αυτόματη Έξοδος",
      unsuccessfulLoginAttempt: "Αποτυχημένες Προσπάθειες Εισόδου",
      unsuccessfulLoginLockPeriod: "Ανεπιτυχής περίοδος Κλειδώματος σύνδεσης",
      passCriteriaSetup: "Ρύθμιση Κριτηρίων Κωδικού Πρόσβασης",
      passLength: "Μήκος Κωδικού Πρόσβασης",
      noUniquePassRequired:
        "Αριθμός μοναδικών κωδικών πρόσβασης που απαιτούνται",
      maxPassAge: "Μέγιστη περίοδος κωδικού πρόσβασης",
      acceptableRangeOfChars: "Αποδεκτή γκάμα χαρακτήρων ",
      upperCase: "Κεφαλαίο γράμμα",
      lowerCase: "Μικρό γράμμα",
      numbers: "αριθμοί",
      specialChars: "Ειδικοί χαρακτήρες",
      uniqueSymbols: "Μοναδικά σύμβολα",
      loadingData: "Φόρτωση Δεδομένων...",
      currency: "Νόμισμα",
      codeActivationTime: "Χρόνος Ενεργοποίησης Κώδικα",
      changeGlobalSetting: "Αλλαγή Παγκόσμιων Ρυθμίσεων",
      globalSetting: "Παγκόσμιες Ρυθμίσεις",
      generalSetting: "Γενικές Ρυθμίσεις",
      hour: "Ώρες",
      days: "Ημέρες",
      minutes: "Μήνες",
      perDay: "Ανά Ημέρα",
      perHour: "Ανά ώρα",
      customised: "Προσαρμοσμένο",
    },
    coffeeData: {
      windBreaker: "Δέντρο Προστασίας από τον Άνεμο",
      horticultureInfo: "Δενδροκηπευτικά",
      shadeTree: "Δέντρο σκιάς",
      coffeeVariety: "Ποικιλία καφέ",
      coffeeSpecies: "Είδη Καφέ",
      updateWindBreaker:
        "Ενημέρωση τύπου δέντρου που προστατεύει από τον άνεμο",
      addWindBreaker: "Προσθήκη Νέου Τύπου Δέντρου windBreaker",
      updateHorticultureInfo: "Ενημέρωση τύπου δέντρου δενδοκηπευτικού",
      addHorticultureInfo: "Προσθήκη νέου τύπου δέντρου κηπευτικών πληροφοριών",
      updateShadeTree: "Ενημέρωση Τύπου Δέντρου Σκιάς",
      addShadeTree: "Προσθήκη Νέου Τύπου Δέντρου Σκιάς ",
      updateCoffeeVariety: "Ενημέρωση Τύπου Δέντρου Ποικιλίας Καφέ",
      addCoffeeVariety: "Προσθήκη νέου τύπου δέντρου τύπου ποικιλίας καφέ",
      deleteVarietyTitle: "Διαγραφή ποικιλίας",
      deleteVarietyMessage:
        "Είστε βέβαιοι ότι θέλετε να διαγράψετε την Ποικιλία;",
      updateCoffeeSpecie: "Ενημέρωση του Είδους Καφέ",
      deleteSpecieTitle: "Διαγραφή είδους",
      deleteSpecieMessage: "Είστε βέβαιοι ότι θέλετε να διαγράψετε το Είδος;",
      addCoffeeSpecie: "Προσθήκη νέου είδους καφέ",
      variety: "Ποικιλία",
      selectVariety: "Επιλέξτε Ποικιλία",
      deleteCoffeeRecord:
        "Είστε βέβαιοι ότι θέλετε να διαγράψετε την καταγραφή;",
      deleteCoffeeData: "Διαγραφή Δεδομένων Καφέ",
      topicRequired: "Απαιτείται όνομα θέματος",
      coffeeAddSuccess: "Το Coffee Speie προστέθηκε με επιτυχία.",
      treeTypeSuccess: "Ο τύπος δέντρου προστέθηκε με επιτυχία.",
      treeTypeUpdateSuccess: "Ο τύπος δέντρου ενημερώθηκε με επιτυχία.",
      coffeeVarietySuccess: "Η ποικιλία καφέ προστέθηκε με επιτυχία.",
      coffeeSpecieSuccess: "Το είδος του καφέ ενημερώθηκε με επιτυχία.",
      nameRequired: "Το όνομα απαιτείται",
      notFound: "Δεν βρέθηκαν δεδομένα Διαχείρισης Καφέ",
    },
    plantation: {
      farmerName: "Όνομα Αγρότη",
      phoneNumber: "Αριθμός Τηλεφώνου",
      plantationName: "Όνομα φυτείας",
      farm: "Φάρμα",
      location: "Τοποθεσία",
      updatePlantationStatus: "Ενημέρωση Κατάστασης Φυτείας",
      update: "Ενημέρωση",
    },
    memberDataSection: {
      coffeeType: "Τύπος Καφέ",
      buyingStationDetails: "Λεπτομέρειες Σταθμού Αγοράς",
      buyingStationUsers: "Χρήστες Σταθμού Αγοράς",
      activityLog: "Αρχείο Δραστηριότητας",
    },
    dashboardReports: {
      appDataReports: "Αναφορές Δεδομένων Εφαρμογής",
      reports: "Αναφορές",
    },
    cropsReport: "Αναφορά Καλλιεργειών",
    today: "Σήμερα",
    week: "Εβδομάδα",
    month: "Μήνας",
    year: "Έτος",
    all: "Όλα",
    cropsStatistics: "Στατιστικά Καλλιεργειών",
    crops: "Καλλιέργειες",
    acres: "Στρέμματα",
    totalPlantedArea: "Συνολική Καλλιεργούμενη Περιοχή",
    farmersChart: "Γράφημα Αγροτών",
    cropsName: "Όνομα Καλλιέργειας",
    farmers: "Αγρότες",
    farms: "Αγροκτήματα",
    planted: "Καλλιεργούνται",
    plantedArea: "Καλλιεργούμενη Περιοχή",
    harvested: "Συγκομίστηκαν",
    yieldAcre: "Απόδοση/Στρέμμα",
    selectCrop: "Επιλογή Καλλιέργειας",
    listByYield: "Λίστα με Απόδοση",
    listByPlantedArea: "Λίστα με Καλλιεργούμενη Περιοχή",
    equipmentReport: "Αναφορά Εξοπλισμού",
    equipmentChart: "Διάγραμμα Εξοπλισμού",
    selectFarmer: "Επιλογή Αγρότη",
    selectFarmers: "Επιλογή Αγροτών",
    equipmentName: "Όνομα Εξοπλισμού",
    region: "Περιοχή",
    counts: "Μετρήσεις",
    large: "Μεγάλο",
    medium: "Μεσαίο",
    small: "Μικρό",
    listByFarmer: "Λίστα με Αγρότη",
    rowsPerPage: "Γραμμές ανά Σελίδα",
    farmersReport: "Αναφορά Αγροτών",
    farmersStatistics: "Στατιστικά Αγροτών",
    averageFarmerLand: "Μέσος Όρος Γαιών ανά Αγρότη",
    largeFarmers: "Μεγάλοι Αγρότες",
    mediumFarmers: "Μεσαίοι Αγρότες",
    smallFarmers: "Μικροί Αγρότες",
    listByLand: "Λίστα με Γη",
    listByFarm: "Λίστα με Αγρόκτημα",
    AvgLandAcre: "Μέση Γαία ανά Στρέμμα",
    listbyCrop: "Λίστα με Καλλιέργεια",
    listbyZone: "Λίστα με Ζώνη",
    farmName: "Όνομα Αγροκτήματος",
    zones: "Ζώνες",
    area: "Περιοχή",
    goalsAchievedReport: "Αναφορά Επιτευγμένων Στόχων",
    listByCrops: "Λίστα με Καλλιέργειες",
    goalsAchievedChart: "Διάγραμμα Επιτευγμένων Στόχων",
    goalsAchieved: "Επιτευγμένοι Στόχοι",
    goalsFailed: "Αποτυχημένοι Στόχοι",
    successRate: "Ποσοστό Επιτυχίας",
    achieved: "Επιτευγμένο",
    equipment: "Εξοπλισμός",
    pests: "Ενοχές",
    regions: "Περιοχές",
    filterByCrops: "Φίλτρο ανά Καλλιέργειες",
    searchCrops: "Αναζήτηση Καλλιεργειών",
    batchCode: "Κωδικός Παρτίδας",
    batchRating: "Βαθμολογία Παρτίδας",
    MakeASelection: "Κάντε μια Επιλογή",
    typeTotalCoffeeQuantity: "Πληκτρολογήστε το Συνολικό Ποσό Καφέ",
    typeHumidity: "Πληκτρολογήστε την Υγρασία",
    valueInPercent: "Τιμή σε Ποσοστό",
    purchaseOrderRequired: "Απαιτείται Παραγγελία Αγοράς",
    totalCoffeeCherryRequired: "Απαιτείται Συνολική Ποσότητα Καφέ Cherry",
    processTypeRequired: "Απαιτείται Τύπος Διαδικασίας",
    stationInfo: "Πληροφορίες Σταθμού",
    purchaseOrders: "Παραγγελίες Αγοράς",
    processingBatch: "Παρτίδα Επεξεργασίας",
    processedCoffeeOutRequired: "Απαιτείται Επεξεργασμένος Καφές Εξόδου",
    lotNo: "Αριθμός Παρτίδας",
    addNewS: "Προσθήκη Νέου",
    viewAll: "Προβολή Όλων",
    parchmentOut: "Έξοδος Περγαμίνου",
    processingDone: "Ολοκλήρωση Επεξεργασίας",
    farmerLotID: "Ταυτότητα Αγρότη και Παρτίδας",
    weight: "Βάρος",
    plantationSettings: "Ρυθμίσεις Φυτείων",
    PlantationsEachFarmerCanCreate:
      "Αριθμός Φυτειών που Μπορεί να Δημιουργήσει κάθε Αγρότης",
    manageAdditionalPlantationRequests:
      "Διαχείριση Αιτημάτων για Πρόσθετες Φυτείες",
    autoApprove: "Αυτόματη Έγκριση",
    adminApprovalRequired: "Απαιτείται Έγκριση Διαχειριστή",
    close: "Κλείσιμο",
    new_user: "Νέος Χρήστης",
    KGAcre: "Κιλά/Στρέμμα",
  },
  oma: {
    // land suitability
    landSuitibility: "Καταλληλότητα της Γης",
    landSuitibilityReport: "Αναφορά Ακαταλληλότητας της Γης",
    generateNewReport: "Δημιουργία Νέας Αναφοράς",
    operatorName: "Όνομα Χειριστή",
    issueDate: "Ημερομηνία Έκδοσης",
    chooseYourLocation: "Επιλέξτε τη Θέση Σας",
    getLandEvaluation: "Λήψη Αξιολόγησης της Γης",
    downloadPdfReport: "Λήψη αναφοράς σε μορφή PDF",
    pleaseEnterCoordinateText:
      "Παρακαλώ εισαγάγετε τις συντεταγμένες (γεωγραφικό μήκος και πλάτος) της τοποθεσίας του αγρού για να δείτε το βαθμό του.",
    noRecordAvailable: "Δεν υπάρχουν διαθέσιμα αποτελέσματα.",
    overallScoreForLand: "Συνολική Βαθμολογία για την Καταλληλότητα της Γης",
    landEvaluation: "Αξιολόγηση της Γης",
    unsuitable: "Ακατάλληλο",
    marginally: "Ελάχιστα",
    suitable: "Κατάλληλο",
    moderately: "Μετρικά",
    highly: "Υψηλά",
    back: "Πίσω",
    search: "Αναζήτηση",
    showResults: "Εμφάνιση Αποτελεσμάτων",

    // weather analysis
    weatherAnalysisReport: "Αναφορές Ανάλυσης Καιρού",
    weatherAnalysis: "Ανάλυση Καιρού",
    getWeatherAnalysis: "Λήψη Ανάλυσης Καιρού",
    weatherReport: "Αναφορά Καιρού",
    filterByDate: "Φιλτράρισμα ανά ημερομηνία",
    insertCoordinateText:
      "Εισαγάγετε τις συντεταγμένες της τοποθεσίας του αγρού (ή δέντρου) παραπάνω, ή χρησιμοποιήστε το χάρτη παρακάτω για να ενδείξετε την τοποθεσία του αγρού (ή δέντρου).",

    addTreeGeolocation: "Προσθήκη Γεωγραφικής Τοποθεσίας Δέντρου",
    editTreeGeolocation: "Επεξεργασία Γεωγραφικής Τοποθεσίας Δέντρου",
    plantationDate: "Ημερομηνία Φύτευσης",
    notes: "Σημειώσεις",
    uploadTreeImages: "Μεταφόρτωση Εικόνων Δέντρου",

    valueAtTheCoordinatesOfInterest: "Τιμή στην Συντεταγμένη του Ενδιαφέροντος",
    "Slope (%)": "Κλίση (%)",
    "Soil texture (USDA class)": "Υφή εδάφους (κλάση USDA)",
    "Coarse fragments (vol%)": "Κονίαμα (vol%)",
    Land: "Γη",
    "Artificial surfaces (type)": "Τεχνητές επιφάνειες (τύπος)",
    "Proximity to Type 1 and 2 Roads (meters)":
      "Εγγύτητα σε Δρόμους Τύπου 1 και 2 (μέτρα)",
    "Soil Chemical Properties": "Χημικές Ιδιότητες Εδάφους",
    "Soil Physical Properties": "Φυσικές Ιδιότητες Εδάφους",
    "Soil organic carbon (%)": "Οργανικό άνθρακα του εδάφους (%)",
    "Soil pH": "pH του εδάφους",
    "Soil salinity (ECe))": "Αλάτωση εδάφους (ECe)",
    "Mean annual temperature (°C)": "Μέση ετήσια θερμοκρασία (°C)",
    Weather: "Καιρός",
    "Mean minimum temperature of coldest month (°C)":
      "Μέση ελάχιστη θερμοκρασία του πιο κρύου μήνα (°C)",
    "Mean annual precipitation (mm)": "Μέση ετήσια βροχόπτωση (mm)",
  },
  deforestation: {
    eudrComplianceStatus: "Κατάσταση Συμμόρφωσης EUDR",
    deforestationComplianceReport: "Αναφορές Συμμόρφωσης Αποδάσωσης",
    noDeforestationComplianceReport:
      "Δεν Βρέθηκε Αναφορά Συμμόρφωσης Αποδάσωσης",
    loadingDeforestationComplianceReport:
      "Φόρτωση Αναφοράς Συμμόρφωσης Αποδάσωσης",
    farmName: "Όνομα Αγροκτήματος",
    farmRegistrationId: "Αριθμός Εγγραφής Αγροκτήματος",
    farmerName: "Όνομα Αγρότη",
    farmerRegistrationId: "Αριθμός Εγγραφής Αγρότη",
    uniqueFarmerId: "Μοναδικό ID Αγρότη",
    uniqueFarmId: "Μοναδικό ID Αγροκτήματος",
    farmLocation: "Τοποθεσία Αγροκτήματος",
    area: "Περιοχή",
    farmAddress: "Διεύθυνση Αγροκτήματος",
    dateOfRequest: "Ημερομηνία Αίτησης",
    status: "Κατάσταση",
    settings: "Ρυθμίσεις",

    farmLatitude: "Γεωγραφικό Πλάτος Αγροκτήματος",
    farmLongitude: "Γεωγραφικό Μήκος Αγροκτήματος",
    shareQRCode: "Κοινοποίηση QR Κωδικού",
    copy: "Αντιγραφή",

    allCountries: "Όλες οι Χώρες",
    allRegions: "Όλες οι Περιφέρειες",
    allFarms: "Όλα τα Αγροκτήματα",
    viewCertificate: "Προβολή Πιστοποιητικού",

    assignmentIssued: "Εκδόθηκε Ανάθεση",

    complianceCertification: "Πιστοποίηση Συμμόρφωσης",
    noComplianceCertification: "Δεν Βρέθηκε Πιστοποίηση Συμμόρφωσης",
    loadingComplianceCertification: "Φόρτωση Πιστοποίησης Συμμόρφωσης",

    eudrForestAssessment: "Αξιολογήσεις Δασών EUDR",
    assessmentReport: "Έκθεση Αξιολόγησης",
    downloadPDF: "Λήψη PDF",
    back: "Πίσω",
    farmDetails: "Λεπτομέρειες Αγροκτήματος",

    dimitraFarmId: "ID Αγροκτήματος Δημήτρα",
    dimitraFermerId: "ID Αγρότη Δημήτρα",

    totalGeofenceAreaHA: "Συνολική Περιοχή Γεωφράγματος (AC)",
    forestLossHA: "Απώλεια Δάσους (AC)",
    forestGainHA: "Κέρδος Δάσους (AC)",
    forestUnchangedHA: "Αμετάβλητο Δάσος (AC)",
    shareCertificate: "Κοινοποίηση Πιστοποιητικού",
    forestUnchanged: "Αμετάβλητο Δάσος",
    forestLoss: "Απώλεια Δάσους",
    forestGain: "Κέρδος Δάσους",
    totalGeofenceArea: "Συνολική Περιοχή Γεωφράγματος",
    print: "Εκτύπωση",
    deforestationProbability: "Πιθανότητα Αποδάσωσης",
    colorCode: "Κωδικός Χρώματος",
    geofenceArea: "Περιοχή Γεωφράγματος",
    percentageOfGeofenceArea: "Ποσοστό Περιοχής Γεωφράγματος",
    view: "Προβολή",
    customization: "Προσαρμογή",
    recordsPerpage: "Αρχεία ανά Σελίδα",
    restoreDefault: "Επαναφορά Προεπιλογών",
    apply: "Εφαρμογή",
    forestAssessmentHelp:
      "Εάν έχετε ερωτήσεις σχετικά με αυτήν την αναφορά ή χρειάζεστε βοήθεια για να την κατανοήσετε, επικοινωνήστε μαζί μας μέσω του Γραφείου Βοήθειας.",
    overallDeforestationProbability: "Συνολική Πιθανότητα Αποδάσωσης",
    zeroOrNegligible: "Μηδενική/Αμελητέα",
    high: "Υψηλή",
    allStatus: "Όλες οι Καταστάσεις",
    low: "Χαμηλή",
    veryHigh: "Πολύ Υψηλή",
    medium: "Μέτρια",
    veryLow: "Πολύ Χαμηλή",
    assessmentIssued: "Εκδόθηκε Αξιολόγηση",
    certificateIssued: "Εκδόθηκε Πιστοποιητικό",
    assessmentNo: "Αριθμός Αξιολόγησης",
    blockchainCertificateDesc:
      "Το Hash Επικύρωσης Πιστοποιητικού Blockchain Θα Είναι Διαθέσιμο Κατά την Αποδοχή του Πιστοποιητικού",
    blockchainValidation: "Επικύρωση Πιστοποιητικού Blockchain",
    openBlockchainPage: "Άνοιγμα Σελίδας Blockchain",
    clickLinkDesc:
      "Κάντε κλικ στον παραπάνω σύνδεσμο για να επικυρώσετε το πιστοποιητικό στο blockchain",
    tooltip: {
      dimitraFarmId:
        "Μοναδικό αναγνωριστικό που σχετίζεται με ένα συγκεκριμένο αγρόκτημα στο σύστημα Δημήτρα.",
      farmName: "Το καθορισμένο όνομα του αγροκτήματος.",
      farmRegistrationId: "Αριθμός εγγραφής του αγροκτήματος.",
      farmLocation:
        "Συγκεκριμένες γεωγραφικές συντεταγμένες ή τοποθεσία του αγροκτήματος.",
      dimitraFermerId:
        "Μοναδικό αναγνωριστικό που σχετίζεται με έναν μεμονωμένο αγρότη στο σύστημα Δημήτρα.",
      farmerName: "Αναγνώριση του ατόμου που είναι υπεύθυνο για το αγρόκτημα.",
      farmerRegistrationId: "Αριθμός εγγραφής του αγρότη.",
      assessmentNo: "Μοναδικός αριθμός που εκχωρείται στην αξιολόγηση.",
    },
    red: "Κόκκινο",
    Yellow: "Κίτρινο",
    transparent: "Διαφανές",
    darkRed: "Σκούρο Κόκκινο",
    brightRed: "Φωτεινό Κόκκινο",
    orange: "Πορτοκαλί",
    lightBlue: "Ανοιχτό Μπλε",
    teal: "Κυανοπράσινο",
    zeroOrNegligibleProbability: "Μηδενική/Αμελητέα Πιθανότητα Αποδάσωσης",
    riskDetected: "Εντοπίστηκε κίνδυνος",
    zeroOrNegligibleRisk: "Μηδενικός/Αμελητέος κίνδυνος",
        manuallyMitigated: "Χειροκίνητα Μετριασμένο",
    compliant: "Συμμορφούμενος",
    nonCompliant: "Μη συμμορφούμενος",
    veryLowProbability: "Πολύ Χαμηλή Πιθανότητα Αποδάσωσης",
    lowProbability: "Χαμηλή Πιθανότητα Αποδάσωσης",
    mediumProbability: "Μέτρια Πιθανότητα Αποδάσωσης",
    highProbability: "Υψηλή Πιθανότητα Αποδάσωσης",
    veryHighProbability: "Πολύ Υψηλή Πιθανότητα Αποδάσωσης",
    locationName: "Όνομα τοποθεσίας",
  },
  selectFarmers: "Επιλογή Αγροτών",
  pleaseAgreeToDeclaration: "Παρακαλώ συμφωνήστε με τη δήλωση για να ολοκληρώσετε.",
  importProductionPlaceTT: "Επιτρέπει στους χρήστες να εισάγουν δεδομένα τόπου παραγωγής χρησιμοποιώντας επιλογές μεταφόρτωσης ή λήψης αρχείων.",
  defaultCircularGeofence: "Οι φάρμες χωρίς γεωφράχτη ή χωρίς πληροφορίες για το μέγεθός τους θα λάβουν έναν προεπιλεγμένο κυκλικό γεωφράχτη 4 εκταρίων. Εάν το μέσο μέγεθος της φάρμας είναι μικρότερο από 4 εκτάρια, αλλάξτε το προεπιλεγμένο μέγεθος κάνοντας κλικ στο κουμπί 'Επεξεργασία' παρακάτω.",
  accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "Σύμφωνα με το EUDR, οι φάρμες με λιγότερα από 4 εκτάρια δεν απαιτούν πολύγωνο.",
  uploadOneDeforestationAssessmentForAllFarms: "ΑΝΕΒΑΣΤΕ ΜΙΑ ΑΞΙΟΛΟΓΗΣΗ ΑΠΟΨΙΛΩΣΗΣ ΓΙΑ ΟΛΕΣ ΤΙΣ ΦΑΡΜΕΣ",
  uploadAssessment: "Ανέβασμα Αξιολόγησης",
  noUploadToBlockchain: "Δεν υπάρχει μεταφόρτωση στο Blockchain",
  noDataForBlockchain: "Δεδομένου ότι δεν δημιουργήθηκαν αναφορές αποψίλωσης για τους παραγωγικούς χώρους, δεν υπήρχαν δεδομένα για εγγραφή στο blockchain. Εάν αυτό ήταν απροσδόκητο, παρακαλούμε βεβαιωθείτε ότι οι αναφορές για τις φάρμες δημιουργήθηκαν σωστά στα προηγούμενα βήματα."
};
